export default function gallery(){
   const container = document.getElementById("gallery");
   if(!container) return;
   const modal = document.getElementById("gallery-modal");
   const modalImage = modal.getElementsByTagName("img")[0];
   const items = container.getElementsByClassName("kg-image-card");

   modal.addEventListener("click", function(){
      modal.style.display = "none";
   });

   for(let n = 0; n < items.length; ++n){
      items[n].addEventListener("click", function(event){
         modalImage.src = event.currentTarget.getElementsByTagName("img")[0].src;
         modal.style.display = "flex";
      });
   }

   // Make sure images are square
   if(CSS.supports("aspect-ratio", "1") == false){
      let onResize = function(){
         for(let n = 0; n < items.length; ++n){
            if(items[n].clientWidth != items[n].clientHeight){
               items[n].style.height = items[n].clientWidth + "px";
            }
         }
      };
      onResize();
      window.addEventListener("resize", onResize);
   }
}
